export enum LocalityType {
    None = 0,
    Municipality = 1,
    District = 2,
    Province = 3,
}
